import React from 'react';
import { PageJumper } from './PageJumper';
import { PageToggler } from './PageToggler';
import { RowCounter } from './RowCounter';
import styles from './Pagination.scss'; // Computes the current range of records being shown based on current page index
// and the number of records displayed per a page.
// Page indexing begins at 1 (the first page of results).

function getRangeOfRecordsShown(currentPage, recordsPerPage, totalRecordsCount) {
  var offset = (currentPage - 1) * recordsPerPage;

  if (offset + recordsPerPage > totalRecordsCount) {
    return {
      start: offset + 1,
      end: totalRecordsCount
    };
  }

  return {
    start: offset + 1,
    end: offset + recordsPerPage
  };
} // Returns the total number of pages. Calculated based on how many records
// exist in total and how many records we show per a page.


function getTotalPageCount(recordsPerPage, totalRecordsCount) {
  return Math.ceil(totalRecordsCount / recordsPerPage);
}

var createGoToNextPageHandler = function createGoToNextPageHandler(currentPage, callback) {
  return function () {
    return callback(currentPage + 1);
  };
};

var createGoToPrevPageHandler = function createGoToPrevPageHandler(currentPage, callback) {
  return function () {
    return callback(currentPage - 1);
  };
};

export var Pagination = function Pagination(props) {
  var currentPage = props.currentPage,
      recordsPerPage = props.recordsPerPage,
      totalRecordsCount = props.totalRecordsCount,
      recordTypeLabel = props.recordTypeLabel,
      onGoToPage = props.onGoToPage;
  var rangeOfRecordsShown = getRangeOfRecordsShown(currentPage, recordsPerPage, totalRecordsCount);
  var totalPageCount = getTotalPageCount(recordsPerPage, totalRecordsCount);
  return React.createElement("div", {
    className: styles.container,
    "data-test": "table-pagination",
    "data-test-records-visible-count": rangeOfRecordsShown.end - rangeOfRecordsShown.start + 1,
    "data-test-total-record-count": totalRecordsCount,
    "data-test-current-page": currentPage,
    "data-test-total-page-count": totalPageCount
  }, React.createElement(RowCounter, {
    rangeOfRecordsShown: rangeOfRecordsShown,
    totalRecordsCount: totalRecordsCount,
    recordTypeLabel: recordTypeLabel
  }), React.createElement("div", {
    className: styles.pageControls
  }, React.createElement(PageJumper, {
    disabled: totalRecordsCount <= recordsPerPage,
    totalPageCount: totalPageCount,
    onGoToPage: onGoToPage
  }), React.createElement("div", {
    className: styles.divider
  }), React.createElement(PageToggler, {
    currentPage: currentPage,
    totalPageCount: totalPageCount,
    onGoToNextPage: onGoToPage && createGoToNextPageHandler(currentPage, onGoToPage),
    onGoToPrevPage: onGoToPage && createGoToPrevPageHandler(currentPage, onGoToPage)
  })));
};